import React from 'react'

const Memories = () => {
    return (
        <div className="container memories">
            <div className="row">
                <div className="col-12">

                    <h3>Chennai Nanbargal Nala Mandram – Office Memories:</h3>
                    <p>From beginning Chennai Nanbargal Nala Mandram office functioning the following places.</p>

                    <ol><li>Thiru.T. Arunachalam – House (No.7, Gangaiamman Koil Street, Old Washermenpet, Chennai-600 021.)</li>
                        <li>Thiru.T. Venkatesan – House (Sendhan Press) Brother of J. Vinayagam. MLA is one of the sacrifies self-interest member joined with the “Makkal Porattam” for combine Thiruthani with Tamil Nadu State. His house at Saitoji Street, Chintadripet, Chennai-600 002.</li>
                        <li>House No.27, Ulagappa Mestri Street, Chintadripet, Chennai-600 002.</li>

                        <li>Thiru. Poonga Radhakrishnan House – Two Years (House No.12, Rajendra Prasad Road, West Mambalam).</li>

                        <li>Thiru.Karumari J. Srinivasan House – One year (House No.15, Dharmaraja Koil Street, Saidapet, Chennai-600 015.)</li>

                    </ol>

                    <ol>
                        <li>President	-	Thiru.C.V. Balasundaram. M.A.
                        </li>
                        <li>Secretary	-	Thiru.M. Mannathan</li>
                    </ol>
                    <p>Thiru.R. Ekambaram M.D. of R.E.-Construction given labours help to Construct the building of our Chennai Nanbargal Nala Mandram Office.</p>


                </div>
            </div>
        </div>


    )
}

export default Memories
